import { useMemo } from 'react';
import trimStart from 'lodash/trimStart';
// @ts-ignore
import { IDocument, IViewProps } from './grid/index.tsx';

const useHref = ({
  isPro,
  bucket,
  hash,
  name,
  extension,
  link,
  progress,
}: // eslint-disable-next-line no-undef
Partial<IDocument> & Partial<IViewProps>) =>
  useMemo((): string => {
    let res = '';
    if (isPro) {
      if (bucket) {
        res = `/pro/${bucket}/${hash}/${encodeURIComponent(name)}/${extension}`;
      } else {
        res = link;
      }
    } else {
      res = progress === 100 ? `/tender/doc/${hash}/${encodeURIComponent(name)}/${extension}` : '#';
    }
    return res;
  }, [isPro, bucket, hash, name, extension, link]);

// eslint-disable-next-line no-undef
const useExtension = ({ extension, name }: Partial<IDocument>) =>
  useMemo((): string | null => {
    if (extension) return trimStart(extension, '.');
    if (name && name.includes('.')) {
      const splitName = name.split('.');
      return splitName[splitName.length - 1];
    }

    return '';
  }, [extension, name]);

export { useHref, useExtension };
